import { render, staticRenderFns } from "./UpdateTask.vue?vue&type=template&id=c5b48dba&scoped=true"
import script from "./UpdateTask.vue?vue&type=script&lang=js"
export * from "./UpdateTask.vue?vue&type=script&lang=js"
import style0 from "./UpdateTask.vue?vue&type=style&index=0&id=c5b48dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b48dba",
  null
  
)

export default component.exports